import {MultiAccountEquityTicketService} from "./MultiAccountEquityTicketService";
import {MultiAccountOrdersDialogService} from "./MultiAccountOrdersDialogService";

export default function() {
    return angular.module("tfApp.portfolio.ticket.multi-account-ticket", [])
                  .service(MultiAccountEquityTicketService.id, MultiAccountEquityTicketService)
                  .service(MultiAccountOrdersDialogService.id, MultiAccountOrdersDialogService)
                  .name;
}
